module.exports = __webpack_public_path__ + "4e5a09d63ee665845290b07b631edbd5.png";